export const MODAL_TOUCHPOINT_HEADLINE_INFO_TOGGLE = 'MODAL_TOUCHPOINT_HEADLINE_INFO_TOGGLE';

export function toggleTouchpointHeadlineInfoModal(isOpen, modalContent) {
  return {
    type: MODAL_TOUCHPOINT_HEADLINE_INFO_TOGGLE,
    payload: {
      isOpen,
      modalContent,
    },
  };
}
